import { ServiceData } from '../../service';
import db from '../../index';
import { entityServiceFactory } from '../../entityServiceFactory';

export interface WorktypesServiceData extends ServiceData {}
const { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain } =
  entityServiceFactory<WorktypesServiceData>(db, 'worktypesService');

export { add, clear, addSync, stopDownloading, get, reset, requestDownloadAgain };
